import {
  DiagnosticCategory,
  readConfigFile,
  sys as typescriptSys,
} from 'typescript';
import {
  getTSConfigFilePath,
  TS_CONFIG_FILENAME,
} from '@wix/cli-core-definitions';
import { writeJson } from '@wix/cli-fs';
import { tsConfigSchema } from '@wix/cli-app-definitions';
import { CliError, CliErrorCode } from '@wix/cli-error';

export function readTSConfig(projectFolder: string) {
  const tsConfigResult = readConfigFile(
    getTSConfigFilePath(projectFolder),
    typescriptSys.readFile
  );

  if (tsConfigResult.error?.category === DiagnosticCategory.Error) {
    if (tsConfigResult.error.code === 5083) {
      throw new CliError({
        code: CliErrorCode.TSConfigNotFound({
          configPath: TS_CONFIG_FILENAME,
        }),
        cause: tsConfigResult.error.messageText,
      });
    }

    throw new CliError({
      code: CliErrorCode.InvalidTSConfigError({
        configPath: TS_CONFIG_FILENAME,
      }),
      cause: tsConfigResult.error.messageText,
    });
  }

  const config = tsConfigSchema.safeParse(tsConfigResult.config);

  if (config.success) {
    return config.data;
  }

  throw new CliError({
    code: CliErrorCode.InvalidConfigSchemaError({
      configPath: TS_CONFIG_FILENAME,
      zodError: config.error,
    }),
    cause: config.error,
  });
}

export async function saveTSConfig(
  projectFolder: string,
  config: Record<string, unknown>
) {
  await writeJson(getTSConfigFilePath(projectFolder), config, { spaces: 2 });
}
